// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsFranchises_ConfigurarWebhookInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payments/accounts/configurar_webhook/{id}
 *
 * Configures webhook for an existing subaccount.
 */
import { registerContract } from './validate'

export interface SubaccountsFranchises_ConfigurarWebhookInput {
events?: string[]
enabled?: boolean
notification_email?: string
}

registerContract('SubaccountsFranchises_ConfigurarWebhookInput', {
  events:             { type: 'array',   required: false },
  enabled:            { type: 'boolean', required: false },
  notification_email: { type: 'string',  required: false },
})
